import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import notification from "../../containers/Landing/LandingIconsWhite/Icon-Notifications-White.png"

import { colors } from '../../constants'

const Notifications = styled.div`
    color: ${colors.greylighter};
    cursor: pointer;
    position: relative;
    height: 30px;

    &:active,
    &:focus,
    &:hover {
        color: ${colors.greylight};
    }
` 

const NotificationsBadge = styled.div`
    top: 2px;
    position: absolute;
    left: 55%;
    background: ${colors.orange};
    border-radius: 50%;
    height: 10px;
    width: 10px;
`

const Shortcut = ({ onClick, withAlert }) => (
    <Notifications onClick={onClick}>
        <div className='notification-icon'>
            <img src={notification} alt="notification icon"/>
        </div>
        {withAlert && <NotificationsBadge />}
    </Notifications>
)

Shortcut.propTypes = {
    onClick: PropTypes.func,
    withAlert: PropTypes.bool,
}

Shortcut.defaultProps = {
    onClick: () => null,
    withAlert: false,
}

export default Shortcut
